import React from 'react'

import type { TMultiOptionsConfigDto } from '@homepal/api-contract'

import { useConfigs } from 'redux/hooks/Configs'
import { GeneralConfigAttribute } from 'types/GlobalConfig'
import { useTranslation } from 'language/translator'
import { joinWithAnd } from 'utils/functions'

import Alert from 'components_new/atoms/Alert'
import Button from 'components_new/atoms/Button'

import { getMultiOptionLabel } from 'components_new/organisms/Configs/utils'

/**
 * Info on the start page when object row types have come into the data since
 * the customer last saved which it includes. Renders nothing when no type is
 * new. It fetches the configurations, so only admins should get it.
 */
const ObjectRowTypesBanner = () => {
  const { t } = useTranslation()

  const { configs } = useConfigs()

  const objectRowTypes = Object.values(configs)
    .map((section) => section.generals[GeneralConfigAttribute.ObjectRowTypes])
    .find(
      (general): general is TMultiOptionsConfigDto =>
        general?.type === 'MULTI_OPTIONS'
    )
  const newLabels = (objectRowTypes?.options ?? [])
    .filter((option) => option.new)
    .map((option) => getMultiOptionLabel(option, t))

  if (newLabels.length === 0) {
    return null
  }

  return (
    <Alert
      action={
        <Button color="info" size="small" to="/settings/config" variant="text">
          {t('global', 'show')}
        </Button>
      }
      severity="info"
      sx={{ alignItems: 'center', mb: 4 }}
    >
      {t(
        'configuration',
        newLabels.length === 1 ? 'new_types_banner_one' : 'new_types_banner',
        false,
        { types: joinWithAnd({ t, values: newLabels }) }
      )}
    </Alert>
  )
}

export default ObjectRowTypesBanner
